export function formatCuil(raw) {
  if (raw === null || raw === undefined) return "";
  const digits = String(raw).replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 10) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10, 11)}`;
}

export function unformatCuil(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/\D/g, "");
}
